<template>
  <aside v-if="keyword === element">
    <div class="help-text">
      <b-card-group deck>
        <b-card :title="$t(`buyers.add.form.helpText.${keyword}.title`)">
          <p class="card-text">
            {{ $t(`buyers.add.form.helpText.${keyword}.desc`) }}
          </p>
        </b-card>
      </b-card-group>
    </div>
  </aside>
</template>
<script>
export default {
  data() {
    return {
      show: false
    }
  },
  props: ['keyword', 'element']
}
</script>
